import { Routes } from '@angular/router';
import { BalanceComponent } from './balance.component';
import { EarningsComponent } from './earnings/earnings.component';
import { TransactionsComponent } from './transactions/transactions.component';
import { PaymentDetailsComponent } from './payment-details/payment-details.component';
import { CardDetailsComponent } from './card-details/card-details.component';
import { BalanceRootComponent } from './balance-root/balance-root.component';

export const routes: Routes = [
  {
    path: '',
    component: BalanceComponent,
    data: { breadcrumb: 'balance.accountBalance' },
    children: [
      { path: '', component: BalanceRootComponent },
      { path: 'earnings', component: EarningsComponent, data: { breadcrumb: 'balance.earningDetails' } },
      { path: 'transactions', component: TransactionsComponent, data: { breadcrumb: 'balance.transactionHistory' } },
      { path: 'payments/:id', component: PaymentDetailsComponent, data: { breadcrumb: 'balance.paymentDetails' } },
      { path: 'card-details', component: CardDetailsComponent, data: { breadcrumb: 'balance.cardDetails' } }
    ]
  }
];
